'use strict';

import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { customEvent } from '@jspartials/general-utils';

// Selectors
const selector = {
  customerArea: '.js-customer-area',
  header: {
    accountButton: '.js-header__account-button'
  }
};

// Elements
const element = {
  header: {
    accountButton: document.querySelector(selector.header.accountButton) || null
  }
};

// Functions

/**
 * Listen header account button click event
 * @returns {void}
 */
const listenHeaderAccountButton = () => {
  if (element.header.accountButton) {
    listenDOMEvent(
      element.header.accountButton,
      'click',
      handleClickAccountButton
    );
  }
};

/**
 * Handle click on account button in header
 * @param {Event} event - Event object from the click
 * @returns {void}
 */
const handleClickAccountButton = (event) => {
  const accountButton = event.target.closest(selector.header.accountButton);
  const sidebarDrawer = accountButton?.dataset?.sidebarDrawer;
  const redirectUrl = accountButton?.dataset?.redirect;
  const isLoginAndSignupPage = accountButton?.dataset?.isLoginAndSignupPage;
  const isLoginAndSignupPageValue = isLoginAndSignupPage
    ? JSON.parse(isLoginAndSignupPage)
    : false;
  const isCustomerAreaPage =
    document.querySelector(selector.customerArea) || null;

  if (redirectUrl && (isLoginAndSignupPageValue || isCustomerAreaPage)) {
    window.location.href = redirectUrl;
  } else {
    document.dispatchEvent(
      new CustomEvent(customEvent.sidebar.open, {
        detail: {
          drawer: sidebarDrawer,
          trigger: accountButton
        }
      })
    );
  }
};

document.addEventListener('DOMContentLoaded', function () {
  // Listen header account button click event
  listenHeaderAccountButton();
});
